"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@mui/material/styles");
var _Button = _interopRequireWildcard(require("@mui/material/Button"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var FlatButton = (0, _styles.styled)(_Button.default)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 20,
  display: "inline block",
  width: "fit-content",
  padding: '10px 32px',
  margin: "1em auto",
  borderColor: "#fff",
  lineHeight: 1.5,
  backgroundColor: '#fff',
  fontWeight: 700,
  borderRadius: 5,
  '&:hover': {
    backgroundColor: "#fff",
    boxShadow: 'rgb(255 255 255 / 50%) 0px 2px 4px -1px, rgb(255 255 255 / 14%) 0px 2px 2px 0px, rgb(0 0 0 / 52%) 0px 1px 10px 0px'
  },
  '&:focus': {
    boxShadow: '0 0 0 0.2rem rgba(255,255,255,.05)'
  },
  '&:disabled': {
    opacity: 0.7
  }
});
var _default = FlatButton;
exports.default = _default;